import React, { memo } from 'react';

interface NavigationButtonsProps {
  currentSection: number;
  totalSections: number;
  onPrevious: () => void;
  onNext: () => void;
  isVisible: boolean;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentSection, totalSections, onPrevious, onNext, isVisible
}) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  if (!isVisible || !isMobile) return null;

  const containerStyle: React.CSSProperties = {
    position: 'fixed', bottom: '20px', left: '20px', right: '20px',
    display: 'flex', justifyContent: 'space-between', zIndex: 1000,
  };

  const buttonBaseStyle: React.CSSProperties = {
  padding: '12px 20px',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  border: '1px solid rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  cursor: 'pointer',
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  color: '#1A1A1A',
  boxSizing: 'content-box',
  minWidth: '100px', // 👈 Add this to set a minimum width
  // 👇 Add these to re-center the text inside the button
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

  return (
    <div style={containerStyle}>
      <button style={buttonBaseStyle} onClick={onPrevious} disabled={currentSection === 0}>
        ← Previous
      </button>
      <button style={buttonBaseStyle} onClick={onNext} disabled={currentSection >= totalSections}>
        Next →
      </button>
    </div>
  );
};

export default memo(NavigationButtons);